import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import WrongPathErrorView from "presentational/error/WrongPathErrorView";
import { isValidInput } from "lib/textFilter";
import config from "lib/fr-config";
import { getFullUrl, getEssentialUrl } from "lib/urlQueryParser";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;

RootShortcutOutfit.propTypes = {
  outfitHash: PropTypes.string.isRequired
};

function RootShortcutOutfit(props) {
  const { outfitHash, hasLoggedIn } = props;
  const [validType, setValidType] = useState("pending"); // "pending", "invalid"

  const history = useHistory();

  useEffect(() => {
    isValidShortcutText();
  }, []);

  const isValidShortcutText = () => {
    const isValid = isValidInput("outfitHash", outfitHash);
    if (!isValid) {
      setValidType("invalid");
      return null;
    } else {
      history.replace(getNextUrl(outfitHash));
    }
  };

  const getNextUrl = inputHash => {
    const { refOutfit } = REFERRAL_QUERY_INDEX;

    const nextUrl = getFullUrl({
      url: getEssentialUrl({ type: "outfit" })(inputHash),
      queryObj: { [refOutfit]: hasLoggedIn ? undefined : inputHash }
    });
    return nextUrl;
  };

  return (
    <React.Fragment>
      {validType === "invalid" && <WrongPathErrorView />}
    </React.Fragment>
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(RootShortcutOutfit);
